import * as React from 'react';
import {Link} from "react-router-dom";

interface PaginationProps {
    limit: number;
    offset: number;
    count: number;
    url: (page: number) => string;
}

export const Pagination = (props: PaginationProps) => {
    const { limit, offset, count, url } = props;

    return <nav aria-label="Navigation">
        <ul className="pagination justify-content-center">
            { offset >= limit && (
                <li className="page-item">
                    <Link className="page-link" to={url(0)} aria-label="Previous">
                        <span aria-hidden="true">&laquo;</span>
                        <span className="sr-only">Previous</span>
                    </Link>
                </li>
            ) }

            { [-3, -2, -1, 0, 1, 2, 3].map(item => {
                const offset_to_set = offset + limit * item;

                if (item === 0) {
                    return <li className="page-item active" key={item}>
                        <a className="page-link" href="#">{offset / limit + 1}</a>
                    </li>
                } else if (offset_to_set >= 0 && offset_to_set <= count) {
                    return <li className="page-item" key={item}>
                        <Link className="page-link" to={url(offset_to_set)}>{ offset_to_set / limit + 1 }</Link>
                    </li>
                }

                return null;
            }) }

            { offset + limit <= count && (
                <li className="page-item">
                    <Link className="page-link" to={url(count - count % limit)} aria-label="Next">
                        <span aria-hidden="true">&raquo;</span>
                        <span className="sr-only">Next</span>
                    </Link>
                </li>
            ) }
        </ul>
    </nav>
};
